<style>
    .cdk-overlay-container {
        z-index: 2000;
    }

    /*.cdk-overlay-pane {
        position: absolute;
        pointer-events: auto;
        box-sizing: border-box;
        z-index: 1000;
        display: flex;
        max-width: 100%;
        max-height: 100%;
    }

    ::ng-deep .cdk-overlay-container mat-datepicker-content {
        z-index: 2000;
    }*/

    svg:focus{
        outline: none !important;
    }

  button:focus{
      outline: none !important;
  }
</style>

<div class="container-fluid padMob " style="padding-left: 15px; ">
    <div class="row ">
        <div class="col-md-8 col-10 col-sm-12 pad0  padHeder"  style="padding-bottom: 0px;" >
            <h4>{{prTypeID == 1 ? 'Create Production Job' : 'Create Project'}}</h4>
            <!-- <h4>{{isFromProjectMod == false ? 'Create Production Job' : 'Create Project'}}</h4> -->
    
        </div>
        <div class="col-md-4 col-2 col-sm-12 pad0  padHeder"  style="padding-bottom: 0px;" (click) = "close()">
            <i class="closeMdl zmdi zmdi-close" style="float: right;"></i>
        </div>
        <div class="col-md-12 col-12 col-sm-12 pad0  padHeder" style="padding-left: 15px; text-align: left;padding-top: 10px;" (click)="open(mymodal)">
            <span class="btn btn-darkGreen-alt brdrRadius3"  style="padding: 6px 8px; cursor:pointer;">Create without order</span>
            <!-- <span class="label brownBadge "  style="cursor:pointer;margin-left: 10px;"> Overdue 4</span>
             -->
        </div>
        <!-- <div class="col-md-12 col-12 col-sm-12 pad0  padHeder text-center" style="padding-top: 0px;padding-bottom: 5px;">
        <span style="color: #777;">Search & Select order</span>
            </div> -->
        <div class="col-md-12 col-12 col-sm-12 pad0  padHeder" style="padding: 0px 15px 20px 15px;">
            <div class="input-icons search">
                <span class="fa fa-search" style="color: #999;"></span>
                <input class="form-control searchBar brdrRadius3" [(ngModel)]="search" placeholder="Search & Select order" style="padding-left: 35px !important; box-shadow: none; width: 100%; float: left;" type="text">
            </div>
        </div>
        <div class="col-md-12 col-12 col-sm-12 pad0" style="height: 360px;overflow: auto;">
            <div class="col-md-12 col-12 col-sm-12 pad0" style="height: 330px;overflow: auto;">
           
        <div class="col-md-12 col-sm-12 col-12 pad0  pad15" 
        *ngFor="let x of productionList |filter:'Item,OrderQty,SU,BuyexrCompName,OrderNo,DueDT' : search"
         (click) = "openWithOrder('',x)" style="padding-bottom: 0px;font-size: 14px ;border-top: 10px solid #f5f5f5;">
            <div class="col-md-12 col-12 col-sm-12 pad0">
                <div class="col-md-8 col-8 col-sm-8 pad0 inLneBlk">
                    <span style="font-weight: bold;">{{x.Item}}</span>
                </div>
                <div *ngIf="prTypeID == 1" class="col-md-4 col-4 col-sm-4 pad0 inLneBlk txtRight">
                    <span style="color: #4caf50 ;">  {{x.OrderQty}} {{x.SU}}</span>
                </div>
            </div>
            <div class="col-md-12 col-12 col-sm-12 pad0">
                <div class="col-md-8 col-8 col-sm-8 inLneBlk pad0">
                    <span style="color: #777;">{{x.BuyexrCompName}}</span>
                </div>
                <div class="col-md-4 col-4 col-sm-4 inLneBlk pad0 txtRight">
                    <span style="color: #777;"><i class="fa fa-industry" aria-hidden="true" style="margin-right:2px; vertical-align: text-top;font-size: 12px;"></i> {{x.OrderQty}} {{x.SU}}</span>
                </div>
            </div>
            <div class="col-md-12 col-12 col-sm-12 pad0">
                <div class="col-md-8 col-8 col-sm-8 inLneBlk pad0">
                    {{x.OrderNo }}
                </div>
                <div class="col-md-4 col-4 col-sm-4 inLneBlk pad0 txtRight">
                    <span style="color: #777;">{{x.DueDT | date: 'dd/MM/yyyy'}}</span>
                </div>
            </div>
        </div>
        </div>
        </div>
    </div>
    </div>
    
<div style="display: none;" (click)="open(mymodal)" id="withoutOrder"></div>
    
 <!--Voucher Entry Modal-->
 <ng-template #mymodal let-modal>
  <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <app-create-production-job ></app-create-production-job>
    </div>
</ng-template>